'use strict';

var shiftPlanningModule = angular.module('t2g.shiftPlanning', [
  'gettext',
  'ui.router',
  require('t2g.common.data-access.resource').name,
  require('t2g.common.data-access.shiftPlanning').name,
  require('t2g.common.services.3rdParty').name,
  require('t2g.common.services.notificationService').name,
]);

module.exports = shiftPlanningModule;

shiftPlanningModule.controller('ShiftPlanningCtrl', require('./ShiftPlanningCtrl'));
shiftPlanningModule.controller('WorkingHoursCtrl', require('./workingHours/WorkingHoursCtrl'));
shiftPlanningModule.factory('shiftClipboard', require('./workingHours/shiftClipboardService'));
shiftPlanningModule.factory(
  'workingHoursGenerator',
  require('./workingHours/workingHoursGeneratorService'),
);

shiftPlanningModule.config(function($stateProvider) {
  $stateProvider
    .state('private.main.shiftPlanning', {
      url: '/shift-planning',
      title: 'Working Hours',
      templateUrl: '/app/modules/shiftPlanning/ShiftPlanningView.html?v=4.5.6',
      controller: 'ShiftPlanningCtrl as ShiftPlanningCtrl',
      resolve: {
        employees: function(ResourceDA) {
          return ResourceDA.list().then(function(response) {
            return response.resources;
          });
        },
      },
    })
    .state('private.main.shiftPlanning.workingHours', {
      url: '/:employeeId/:date/?:openTab',
      title: 'Working Hours',
      templateUrl: '/app/modules/shiftPlanning/workingHours/WorkingHoursView.html?v=4.5.6',
      controller: 'WorkingHoursCtrl as WorkingHoursCtrl',
      resolve: {
        shiftPlanning: function(
          $q,
          $stateParams,
          CountryConfig,
          ResourceDA,
          ShiftPlanningDA,
          workingHoursGenerator,
        ) {
          return $q
            .all([
              ResourceDA.get($stateParams.employeeId),
              ShiftPlanningDA.get($stateParams.employeeId, $stateParams.date),
              CountryConfig.get(),
            ])
            .then(function(responses) {
              var employee = responses[0].resource;
              var shifts = responses[1];
              var countryConfig = responses[2];
              var dates = workingHoursGenerator.get(employee, shifts, countryConfig);

              return {
                employee: employee,
                dates: dates,
              };
            });
        },
        office: function(OfficeDA) {
          return OfficeDA.get();
        },
      },
    });
});



// WEBPACK FOOTER //
// ./src/app/modules/shiftPlanning/shiftPlanningModule.js